module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reveal large",
    attrs: {
      "id": 'modal-ytvideo-' + _vm.videoId,
      "data-reveal": ""
    }
  }, [_c('div', {
    staticClass: "responsive-embed widescreen content"
  }, [(_vm.isOpen) ? _c('youtube', {
    attrs: {
      "video-id": _vm.videoId
    },
    on: {
      "ready": _vm.ready
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab6b49ac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/search/SearchYoutubePlayer.vue
// module id = 716
// module chunks = 0